"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defineReactRenderService = void 0;
function defineReactRenderService(isHydrating) {
    return {
        id: "react-render-service",
        create: () => ({
            "1.0.0": () => ({
                featureService: {
                    get hydrating() {
                        return isHydrating();
                    }
                }
            })
        })
    };
}
exports.defineReactRenderService = defineReactRenderService;
//# sourceMappingURL=index.js.map